import React from 'react';
import {FIND_ALL_CIDADES_CAMPANHA as query} from '../../graphql/queries';
import {SelectBase} from '../../components/select/mui-base';

const transformOptions = ({content}) => {
  return Array.isArray(content)
    ? content.map(item => ({
      ...item,
      label: item?.cidade?.nomeEUf,
      value: item.id
    }))
    : [];
};

const getVariables = ({pageNumber, search = '', searchDTO = {}, pageSize = 20}) => {
  return {
    pageable: {pageNumber, pageSize, sortField: 'cidade.nome', sortDir: 'ASC'},
    searchDTO: {
      ...searchDTO,
      search
    }
  };
};

export const SelectCampanhaCidades = (props) => {
  return (
    <SelectBase
      label="Cidade"
      responseObjectName="cidades"
      transformOptions={transformOptions}
      query={query}
      getVariables={(searchProps) => getVariables({...searchProps, ...props})}
      {...props}
    />
  );
};
